var a = {};
export {
  a as __exports
};
//# sourceMappingURL=index.es341.js.map
